import { z } from 'zod';
import type { RefundTypeVariables } from '../../../graphql/mutation/submit';

export type RefundContentData = {
  method?: RefundTypeVariables;
};

export type RefundData = {
  refund?: RefundContentData;
};

export const RefundTaskSchema = z.object({
  method: z.enum(
    [
      'ORIGINAL_PAYMENT',
      'GIFT_CARD',
      'SHOP_NOW',
      'INSTANT_CREDIT',
      'PURCHASE_CARD',
    ],
    {
      error: (issue) =>
        issue.input === undefined
          ? 'Refund method is required'
          : 'Refund method is required', // when the value is null, it is a type error, not a required error
    },
  ),
});
